export default __webpack_public_path__ + "static/media/filmCriticHome.4e73a4d8.png";